import useSWR, { SWRConfiguration } from 'swr';
import { AxiosError } from 'axios';
import hash from 'object-hash';
import { ScroogeProperty } from '../../../providers/api/dtos/scrooge';
import { getScroogeProperties, GetScroogePropertiesFilters } from '../../../providers/api/scrooge/scroogeProvider';
import { PaginatedResult, PaginationParams } from '../../../providers/pagination';
import { useMatchMutate } from '../../../utils/swr/swr';
import { SWRCustomResponse } from '../../../hooks/types';

export const USE_SCROOGE_PROPERTIES_RID = '/scrooge/properties';

export default function useScroogeProperties(
  filters?: GetScroogePropertiesFilters,
  pagination?: PaginationParams,
  options?: SWRConfiguration<PaginatedResult<ScroogeProperty>, AxiosError>,
): SWRCustomResponse<PaginatedResult<ScroogeProperty>, AxiosError> {
  const matchMutate = useMatchMutate();
  const key = [USE_SCROOGE_PROPERTIES_RID, hash({ ...filters, ...pagination })];
  const result = useSWR(key, () => getScroogeProperties(filters, pagination), options);

  return {
    ...result,
    mutate: () => matchMutate(USE_SCROOGE_PROPERTIES_RID),
  };
}
